import {createTheme} from '@mui/material';
import {Localizacion} from 'lib.front';

const today = new Date();
const darkBlue = '#3979AA';

function FormatoFechaUTC(value) {
   if (value) {
      const fecha = new Date(value);
      const mes = fecha.getUTCMonth() + 1;
      const dia = fecha.getUTCDate();
      return `${fecha.getUTCFullYear()}-${mes < 10 ? '0' + mes : mes}-${
         dia < 10 ? '0' + dia : dia
      }`;
   }
   return '-';
}

export const filtrosIniciales = {
   anio: today.getFullYear(),
   mes: (today.getMonth() + 1).toString(),
   moneda: 'USD'
};

export const meses = [
   {value: '1', label: 'Enero'},
   {value: '2', label: 'Febrero'},
   {value: '3', label: 'Marzo'},
   {value: '4', label: 'Abril'},
   {value: '5', label: 'Mayo'},
   {value: '6', label: 'Junio'},
   {value: '7', label: 'Julio'},
   {value: '8', label: 'Agosto'},
   {value: '9', label: 'Septiembre'},
   {value: '10', label: 'Octubre'},
   {value: '11', label: 'Noviembre'},
   {value: '12', label: 'Diciembre'}
];

export const options = {
   filter: false,
   selectableRows: 'none',
   responsive: 'standard',
   expandableRowsHeader: false,
   pagination: true,
   elevation: 0,
   rowsPerPage: 5,
   rowsPerPageOptions: [5, 10, 15, 100],
   search: true,
   print: false,
   download: false,
   viewColumns: false,
   fixedHeader: false,
   selectToolbarPlacement: 'none',
   selectableRowsOnClick: true,
   textLabels: Localizacion.muiDataTables.ES
};

export const column = [
   {
      name: 'codMoneda',
      label: 'Moneda',
      options: {
         sort: false,
         display: true
      }
   },
   {
      name: 'fecha',
      label: 'Fecha',
      options: {
         sort: true,
         display: true,
         customBodyRender: (value, tableMeta, updateValue) => {
            return FormatoFechaUTC(value);
         }
      }
   },
   {
      name: 'compraFiscal',
      label: 'T.C. Compra',
      options: {
         sort: true,
         display: true
      }
   },
   {
      name: 'ventaFiscal',
      label: 'T.C. Venta',
      options: {
         sort: true,
         display: true
      }
   }
];

export const monedas = [
   {
      codMoneda: 'USD',
      simbolo: '$'
   }
];